<lib-background></lib-background>
<lib-layout>
  <div toolbar class="contents">
    <ng-container *ngTemplateOutlet="logo"></ng-container>
    @if (showFullMenu) {
      <dges-full-length-menu [fillerNav]="fillerNav"></dges-full-length-menu>
    } @else {
      <dges-drop-down-menu [fillerNav]="fillerNav"></dges-drop-down-menu>
    }
  </div>

  <router-outlet content></router-outlet>

  <ng-container footer>
    <div
      matRipple
      routerLink="."
      [routerLink]="'timeline'"
      class="flex h-16 flex-auto items-center justify-center"
    >
      <ng-container *ngTemplateOutlet="logo"></ng-container>
    </div>
    <mat-icon
      matRipple
      [matMenuTriggerFor]="routeMenu"
      class="flex h-16 flex-auto items-center justify-center"
      >menu</mat-icon
    >
    <mat-menu #routeMenu="matMenu">
      @for (nav of fillerNav; track nav) {
        <button mat-menu-item routerLink="." [routerLink]="nav.path">
          {{ nav.path }}
        </button>
      }
    </mat-menu>
  </ng-container>
</lib-layout>

<ng-template #logo>
  <dges-logo
    matRipple
    routerLink="."
    [routerLink]="'timeline'"
    class="h-16 cursor-pointer"
    prefix="d"
    accent="ღ"
    suffix="es"
  >
  </dges-logo>
</ng-template>
